import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import Icon from "./Icon";

type ViewOption = {
  value: string;
  label: string;
};

interface ViewSwitchProps {
  options: readonly ViewOption[] | ViewOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export default function ViewSwitch({
  options,
  value,
  onChange,
  className = "",
}: ViewSwitchProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        className={cn(
          "flex h-12 w-auto items-center justify-center gap-2 rounded-none border-brand-border px-3 font-mono text-[11px] uppercase tracking-[0.22em] text-brand-text",
          className
        )}
        aria-label="Select view type"
      >
        <Icon name="toggle" size={16} />
        <SelectValue placeholder="Select view" />
      </SelectTrigger>
      <SelectContent className="w-[200px]" align="end">
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
